// extracted by mini-css-extract-plugin
module.exports = {"work__grid":"Works_work__grid__1EdEE","into":"Works_into__HWBFS","work__Card":"Works_work__Card__1wO8s","work__tag":"Works_work__tag__1ytGb"};